export default __webpack_public_path__ + "static/Standard-44bd52e358c4a838ad83f5a22673bc6e.png";